<template>
  <b-modal
    size="xl"
    :id="id"
    ok-title="Download"
    @ok.prevent="downloadFIle"
    centered
  >
    <div class="text-center">
      <b-img :src="src" alt="/" class="imgg" />
    </div>
  </b-modal>
</template>

<script>
import { BModal, BAvatar, BMedia, BMediaAside, BImg } from "bootstrap-vue";

export default {
  props: {
    src: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: 'preview-file-modal'
    }
  },
  methods: {
    downloadFIle() {
      if (typeof this.src != "string") {
        return;
      }
      const url_parts = this.src.split("/");
      fetch(this.src, {
        responseType: "blob",
      }).then((t) =>
        t.blob().then((b) => {
          const a = document.createElement("a");
          a.href = URL.createObjectURL(b);
          a.setAttribute("download", url_parts.reverse()[0]);
          a.click();
        })
      );
    },
  },
  components: {
    BModal,
    BAvatar,
    BMedia,
    BMediaAside,
    BImg,
  },
};
</script>
<style scoped>
.imgg {
  min-width: 500px;
  max-width: 100%;
  object-fit: contain;
}
</style>
